export const environment = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8080',
  graphqlEndpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT || 'http://localhost:8080/graphql',
  devMode: import.meta.env.VITE_DEV_MODE === 'true',
  mockAuth: import.meta.env.VITE_MOCK_AUTH === 'true',
  b2c: {
    clientId: import.meta.env.VITE_B2C_CLIENT_ID || '',
    authority: import.meta.env.VITE_B2C_AUTHORITY || '',
    // Dedicated sign-up flow for invite activation (lands on the set-password screen).
    // Falls back to the default authority when unset, so behaviour is unchanged.
    signupAuthority: import.meta.env.VITE_B2C_SIGNUP_AUTHORITY || '',
    knownAuthority: import.meta.env.VITE_B2C_KNOWN_AUTHORITY || '',
    apiScope: import.meta.env.VITE_B2C_API_SCOPE || '',
    redirectUri: import.meta.env.VITE_B2C_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri:
      import.meta.env.VITE_B2C_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  },
};
